export const baseApiUrl = process.env.REACT_APP_API_URL || '/api'

const apiUrls = {
  quotationRequestByEmail: () => `${baseApiUrl}/emails`,
  telematPriceIndication: () => `${baseApiUrl}/bondPricing`,
  telematUserInfo: (telematUserId: string) => `${baseApiUrl}/users/${telematUserId}`,
}

export default apiUrls
